import Login from '../views/Login'
import Index from '../views/common/Index'

export default [
    {
        path: '/login',
        name: 'login',
        component: Login,
    },
    {
        path: '/',
        name: 'index',
        meta: {tab: false},
        component: Index,
        redirect: '/home',
        children: [
            {

                path: '/home',
                name: 'home',
                meta: {title: '首页', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/Home'),
            },
            {

                path: '/user-manager/list',
                name: 'user-manager-list',
                meta: {title: '用户列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/user-manager/List'),
            },
            {

                path: '/user-manager/add',
                name: 'user-manager-add',
                meta: {title: '新增用户', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/user-manager/Add'),
            },
            {

                path: '/user-manager/edit',
                name: 'user-manager-edit',
                meta: {title: '编辑用户', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/user-manager/Edit'),
            },
            {

                path: '/dict-manager/list',
                name: 'dict-manager-list',
                meta: {title: '字典列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/dict-manager/List'),
            }, {

                path: '/dict-manager/add',
                name: 'dict-manager-add',
                meta: {title: '新增字典', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/dict-manager/Add'),
            }, {

                path: '/dict-manager/edit',
                name: 'dict-manager-edit',
                meta: {title: '编辑字典', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/dict-manager/Edit'),
            }, {

                path: '/menu-manager/list',
                name: 'menu-manager-list',
                meta: {title: '菜单列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/menu-manager/List'),
            }, {

                path: '/menu-manager/add',
                name: 'menu-manager-add',
                meta: {title: '新增菜单', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/menu-manager/Add'),
            }, {

                path: '/menu-manager/edit',
                name: 'menu-manager-edit',
                meta: {title: '编辑菜单', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/menu-manager/Edit'),
            }, {

                path: '/area-manager/index',
                name: 'menu-manager-index',
                meta: {title: '区域管理', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/area-manager/Index'),
            }, {

                path: '/module-manager/index',
                name: '/module-manager/index',
                meta: {title: '模块管理', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/module-manager/Index'),
            }, {

                path: '/role-manager/list',
                name: '/role-manager/list',
                meta: {title: '角色列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/role-manager/List'),
            }, {

                path: '/role-manager/add',
                name: '/role-manager/add',
                meta: {title: '新增角色', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/role-manager/Add'),
            }, {

                path: '/role-manager/edit',
                name: '/role-manager/edit',
                meta: {title: '编辑角色', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/role-manager/Edit'),
            }, {

                path: '/rule-manager/list',
                name: '/rule-manager/list',
                meta: {title: '权限列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/rule-manager/List'),
            }, {

                path: '/rule-manager/add',
                name: '/rule-manager/add',
                meta: {title: '新增权限', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/rule-manager/Add'),
            }, {

                path: '/rule-manager/edit',
                name: '/rule-manager/edit',
                meta: {title: '编辑权限', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/rule-manager/Edit'),
            }, {

                path: '/action-manager/list',
                name: '/action-manager/list',
                meta: {title: '功能列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/action-manager/List'),
            }, {

                path: '/action-manager/add',
                name: '/action-manager/add',
                meta: {title: '新增功能', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/action-manager/Add'),
            }, {

                path: '/action-manager/edit',
                name: '/action-manager/edit',
                meta: {title: '编辑功能', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/action-manager/Edit'),
            }, {

                path: '/update-user-password',
                name: '/update-user-password',
                meta: {title: '修改用户密码', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/UpdateUserPassword'),
            },
            {

                path: '/update-user-info',
                name: '/update-user-info',
                meta: {title: '修改用户信息', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/UpdateUserInfo'),
            },
            {

                path: '/org-manager-index',
                name: '/org-manager-index',
                meta: {title: '机构管理', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/org-manager/Index'),
            }, {

                path: '/org-manager/add-org',
                name: '/org-manager/add-org',
                meta: {title: '新增机构', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/org-manager/AddOrg'),
            },
            {

                path: '/org-manager/edit-org',
                name: '/org-manager/edit-org',
                meta: {title: '编辑机构', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/org-manager/EditOrg'),
            },
            {
                path: '/org-manager/add-employee',
                name: '/org-manager/add-employee',
                meta: {title: '新增员工', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/org-manager/AddEmployee'),
            },{
                path: '/org-manager/edit-employee',
                name: '/org-manager/edit-employee',
                meta: {title: '编辑员工', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/org-manager/EditEmployee'),
            },{
                path: '/file-category-manager/list',
                name: '/file-category-manager/list',
                meta: {title: '文件类别列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/file-category-manager/List'),
            },{
                path: '/file-category-manager/add',
                name: '/file-category-manager/add',
                meta: {title: '新增文件类别', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/file-category-manager/Add'),
            },{
                path: '/file-category-manager/edit',
                name: '/file-category-manager/edit',
                meta: {title: '编辑文件类别', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/file-category-manager/Edit'),
            },{
                path: '/file-server-manager/add',
                name: '/file-server-manager/add',
                meta: {title: '新增附件服务器', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/file-server-manager/Add'),
            },{
                path: '/file-server-manager/edit',
                name: '/file-server-manager/edit',
                meta: {title: '编辑附件服务器', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/file-server-manager/Edit'),
            },{
                path: '/file-server-manager/list',
                name: '/file-server-manager/list',
                meta: {title: '附件服务器列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/file-server-manager/List'),
            },{
                path: '/file-manager/add',
                name: '/file-manager/add',
                meta: {title: '新增附件', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/file-manager/Add'),
            },{
                path: '/file-manager/edit',
                name: '/file-manager/edit',
                meta: {title: '编辑附件', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/file-manager/Edit'),
            },{
                path: '/file-manager/list',
                name: '/file-manager/list',
                meta: {title: '附件列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/file-manager/List'),
            },{
                path: '/no-permission',
                name: '/no-permission',
                meta: {title: '无权访问该页面', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/NoPermission'),
            },{
                path: '/bus-num-rule-manager/add',
                name: '/bus-num-rule-manager/add',
                meta: {title: '新增业务编号规则', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/bus-num-rule-manager/Add'),
            },{
                path: '/bus-num-rule-manager/edit',
                name: '/bus-num-rule-manager/edit',
                meta: {title: '编辑业务编号规则', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/bus-num-rule-manager/Edit'),
            },{
                path: '/bus-num-rule-manager/list',
                name: 'bus-num-rule-manager/list',
                meta: {title: '业务编号规则列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/bus-num-rule-manager/List'),
            },{
                path: '/operation-log-manager/add',
                name: '/operation-log-manager/add',
                meta: {title: '新增操作日志', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/operation-log-manager/Add'),
            },{
                path: '/operation-log-manager/edit',
                name: '/operation-log-manager/edit',
                meta: {title: '编辑操作日志', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/operation-log-manager/Edit'),
            },{
                path: '/operation-log-manager/list',
                name: 'operation-log-manager/list',
                meta: {title: '操作日志列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/operation-log-manager/List'),
            },{
                path: '/app-manager/add',
                name: '/app-manager/add',
                meta: {title: '新增应用', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/app-manager/Add'),
            },{
                path: '/app-manager/edit',
                name: '/app-manager/edit',
                meta: {title: '编辑应用', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/app-manager/Edit'),
            },{
                path: '/app-manager/list',
                name: 'app-manager/list',
                meta: {title: '应用列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/app-manager/List'),
            },{
                path: '/app-manager/setting',
                name: 'app-manager/setting',
                meta: {title: '应用配置', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/app-manager/Setting'),
            },{
                path: '/system-notice-manager/list',
                name: '/system-notice-manager/list',
                meta: {title: '系统公告列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/system-notice-manager/List'),
            },{
                path: '/system-notice-manager/edit',
                name: '/system-notice-manager/edit',
                meta: {title: '编辑系统公告', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/system-notice-manager/Edit'),
            },{
                path: '/system-notice-manager/add',
                name: '/system-notice-manager/add',
                meta: {title: '新增系统公告', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/system-notice-manager/Add'),
            },
            {
                path: '/area-type-manager/list',
                name: '/area-type-manager/list',
                meta: {title: '区域类型列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/area-type-manager/List'),
            },{
                path: '/area-type-manager/edit',
                name: '/area-type-manager/edit',
                meta: {title: '区域类型编辑', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/area-type-manager/Edit'),
            },{
                path: '/area-type-manager/add',
                name: '/area-type-manager/add',
                meta: {title: '区域类型新增', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/area-type-manager/Add'),
            },
            {
                path: '/mch-account-manager/list',
                name: '/mch-account-manager/list',
                meta: {title: '支付账户列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/mch-account-manager/List'),
            },{
                path: '/mch-account-manager/edit',
                name: '/mch-account-manager/edit',
                meta: {title: '支付账户编辑', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/mch-account-manager/Edit'),
            },{
                path: '/mch-account-manager/add',
                name: '/mch-account-manager/add',
                meta: {title: '支付账户新增', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/mch-account-manager/Add'),
            },
            {
                path: '/banner-setting/list',
                name: '/banner-setting/list',
                meta: {title: 'BANNER列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/banner-setting/List'),
            },{
                path: '/banner-setting/edit',
                name: '/banner-setting/edit',
                meta: {title: 'BANNER编辑', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/banner-setting/Edit'),
            },{
                path: '/banner-setting/add',
                name: 'banner-setting/add',
                meta: {title: 'BANNER新增', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/banner-setting/Add'),
            }

        ]
    },
    {
        path: '*',
        name: '404',
        redirect: '/home'
    },
]
